// styles
import "./Components.css";
import "../pages/project/Project.css";
import { accountDataStore, projectStore } from "../store/Store";
import { MatchingLoads } from "../funcs/helperFuncs";
import DeliveredDate from "./DeliveredDate";

export default function LoadList({
  deliveredLoads,
  isAsset,
  enableCheckBoxes,
  batchLoads,
  setBatchLoads,
  setBatchChecked,
}) {
  // global
  const projectCustomerInvoices = projectStore(
    (data) => data.projectCustomerInvoices
  );
  const accountCustomerInvoices = accountDataStore(
    (data) => data.accountCustomerInvoices
  );
  const InvoiceName = (invId, isAccountInvoice) => {
    var invoice = [];
    if (!isAccountInvoice) {
      if (projectCustomerInvoices) {
        invoice = projectCustomerInvoices.filter((x) => x.id === invId);
      }
    } else {
      if (accountCustomerInvoices) {
        invoice = accountCustomerInvoices.filter(
          (x) => x.id === invId
        );
      }
    }

    if (invoice.length > 0) {
      return invoice[0].invoice_name;
    } else {
      return "";
    }
  };

  const handleCheck = (load, idx) => {
    if (batchLoads.length > 0 && batchLoads[idx]) {
      if (batchLoads[idx].checked) {
        setBatchLoads((current) => {
          const newData = [...current];
          newData[idx] = {
            pc_load_id: null,
            checked: false,
          };
          return newData;
        });
        setBatchChecked(false);
      } else {
        setBatchLoads((current) => {
          const newData = [...current];
          newData[idx] = {
            pc_load_id: load.pc_load_id,
            checked: true,
          };
          return newData;
        });
      }
    } else {
      setBatchLoads(
        Array.from({ length: deliveredLoads.length }, () => ({
          pc_load_id: null,
          checked: false,
        }))
      );
      setBatchLoads((current) => {
        const newData = [...current];
        newData[idx] = {
          pc_load_id: load.pc_load_id,
          checked: true,
        };
        return newData;
      });
    }
  };
  
  return !isAsset ? (
    <>
      {deliveredLoads.map((load, idx) => (
        <tr key={load.id}>
          {enableCheckBoxes && (
            <td>
              <input
                type="checkbox"
                name="check_load"
                onChange={() => handleCheck(load, idx)}
                value={
                  batchLoads.length > 0 && batchLoads[idx]
                    ? batchLoads[idx].checked
                    : false
                }
                checked={
                  batchLoads.length > 0 && batchLoads[idx]
                    ? batchLoads[idx].checked
                    : false
                }
              />
            </td>
          )}
          <td>{load.load_no}</td>
          <DeliveredDate d={load.delivered_date} />
          <td>{load.carrier_name}</td>
          <td>{load.driver_name}</td>
          <td>{load.terminal_name}</td>
          <td>{load.po_number}</td>
          <td>{load.ticket_number}</td>
          <td>{load.ticket_is_missing ? "Yes" : "No"}</td>
          <td>{load.approved_mileage}</td>
          <td>{load.product_name}</td>
          <td>{load.weight_tons.toFixed(2)}</td>
          <MatchingLoads loadNumbers={load.matching_load_numbers} />
          <td>{load.freight_rev.toFixed(2)}</td>
          <td>{load.fsc_rev.toFixed(2)}</td>
          <td>{load.freight_cost.toFixed(2)}</td>
          <td>{load.fsc_cost.toFixed(2)}</td>
          <td>{load.sand_rev.toFixed(2)}</td>
          <td>{load.sand_cost.toFixed(2)}</td>
          <td>{load.locked_reason}</td>
          <td>
            {InvoiceName(load.customer_invoice_id, load.is_account_invoice)}
          </td>
          {load.transfer_type_id === 12 && (
            <td>{`To: ${load.transferred_name}`}</td>
          )}
          {load.transfer_type_id === 11 && (
            <td>{`From: ${load.transferred_name}`}</td>
          )}
          {load.transfer_type_id === 0 && <td></td>}
          <td>{load.driver_ticket_auto_status_name === "Ticket Mismatch" ? "Mismatch" : load.driver_ticket_auto_status_name === "Ticket Match" ? "Match" : "OCR Pending"}</td>
          <td>{load.propconnect_approval_status}</td>
        </tr>
      ))}
    </>
  ) : (
    <>
      {deliveredLoads.map((load) => (
        <tr key={load.id}>
          <td>{load.load_no}</td>
          <td>{load.load_type}</td>
          <DeliveredDate d={load.delivered_date} />
          <td>{load.carrier_name}</td>
          <td>{load.driver_name}</td>
          <td>{load.approved_mileage}</td>
          <td>{load.total_boxes}</td>
          <td>{load.weight_tons.toFixed(2)}</td>
          <td>{load.freight_rev.toFixed(2)}</td>
          <td>{load.fsc_rev.toFixed(2)}</td>
          <td>{load.freight_cost.toFixed(2)}</td>
          <td>{load.fsc_cost.toFixed(2)}</td>
          <td>{load.locked_reason}</td>
          <td>
            {InvoiceName(load.customer_invoice_id, load.is_account_invoice)}
          </td>
          <td>{load.propconnect_approval_status}</td>
        </tr>
      ))}
    </>
  );
}
